import React, { Component } from 'react';
import { Row, Col, Card, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  formatCurrency,
  formatDate,
  formatPercentage,
  capitalize
} from '../../../../../utils/FormatUtil';
import Assessment from '../../../../Assessment';
import './summary.css';
import iconMail from '../../../../../assets/images/icon-mail.svg';
import iconPhone from '../../../../../assets/images/icon-phone.svg';
import iconWeb from '../../../../../assets/images/icon-web.svg';

class Summary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sentValue: false,
    };
  }

  getSentValue = (value) => {
    this.setState({sentValue: value});
  }

  componentDidMount() { 
    const { googleAnalytics } = this.props;
    googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/paso3'});
  }

  render() {
    const { newTimeDeposit, email, rating } = this.props;
    const { sentValue } = this.state;

    return (
      <React.Fragment>
        <Row noGutters className="dap_summary-about">
          <Col md={3} xs={0}/>
          <Col md={1} xs={2} className="dap_summary_right">
            <FontAwesomeIcon icon={faCheckCircle} size="2x" color="#27ae60" className="dap_summary_prop_icon" />
          </Col>
          <Col md={5} xs={10} className="dap_summary_margin_p">
            <p>
              Contratación de Depósito a Plazo realizado con éxito.
            </p>
          </Col>
          <Col md={3} xs={3}/>
        </Row>
        <Card body className="card-xs">
          <Row noGutters>
            <Col md={{ span: 5, offset: 1 }} sm={6} xs={12} className="table_result">
              <h5>Detalle de la inversión</h5>
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="col">Monto invertido</th>
                    <th scope="col">
                      {formatCurrency(newTimeDeposit.montoInvertir)}
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Ganancia</th>
                    <th scope="col">
                      {formatCurrency(
                        newTimeDeposit.montoRecibir -
                          newTimeDeposit.montoInvertir
                      )}
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Monto al vencimiento</th>
                    <th scope="col">
                      {formatCurrency(newTimeDeposit.montoRecibir)}
                    </th>
                  </tr>

                  <tr>
                    <td>Plazo</td>
                    <td>{`${newTimeDeposit.plazo} días`}</td>
                  </tr>

                  <tr>
                    <td>Tipo de depósito</td>
                    <td>{capitalize((newTimeDeposit.tipo).toLowerCase())}</td>
                  </tr>

                  <tr>
                    <td>Fecha de inicio</td>
                    <td>{formatDate(newTimeDeposit.fechaApertura)}</td>
                  </tr>

                  <tr>
                    <td>Fecha de vencimiento</td>
                    <td>{formatDate(newTimeDeposit.fechaVencimiento)}</td>
                  </tr>

                  <tr>
                    <td><br></br></td>
                  </tr>

                  <tr className="dap_verde">
                    <td>Tasa base</td>
                    <td>{formatPercentage(newTimeDeposit.tasaInteres)}</td>
                  </tr>
                  <tr>
                    <th colSpan="6">Tasa definida en base a un período de 30 días.</th>
                  </tr>

                  <tr className="dap_verde">
                    <td>Tasa período</td>
                    <td>{formatPercentage(newTimeDeposit.tasaPeriodo)}</td>
                  </tr>
                  <tr>
                    <th colSpan="6">Tasa de interés total para todo el período estipulado en la captación. Resulta de la división de la Tasa Base por 30 y multiplicándola por el número de días de la Captación.</th>
                  </tr>

                </tbody>
              </table>
              <div className="dap_scroll" />
            </Col>

            <Col
              md={6}
              sm={6}
              xs={12}
              className="dap_summary-info dap_border-izquierda"
            >
              {(rating === 0 || sentValue) &&
              <Row noGutters >
                  <Col md={2} xs={2} className="icon_dap_about_prop_mail">
                    <Image src={iconMail} className="icono_dap_about" alt="Ícono DAP Mail" />
                  </Col>
                  <Col md={10} xs={10}>
                    <p>
                        Un comprobante con el registro de la operación ha sido enviado
                         automáticamente al correo
                      <br />
                      <b>
                        {email}
                      </b>
                    </p>
                  </Col>
                  <Col md={2} xs={2} className="icon_dap_about_prop_web">
                    <Image src={iconWeb} className="icono_dap_about_web" alt="Ícono DAP Web" />
                  </Col>
                  <Col md={10} xs={10}>
                    <p>
                      Para mayor información de esta y otras operaciones, consulta en tu {" "}
                      <b>
                        sitio privado Coopeuch
                      </b>
                    </p>
                  </Col>
                  <Col md={2} xs={2} className="icon_dap_about_prop_phone">
                    <Image src={iconPhone} className="icono_dap_about" alt="Ícono DAP Phone" />
                  </Col>
                  <Col md={10} xs={10}>
                    <p>
                      También puedes llamar a nuestro Contact Center al {" "}
                      <b>
                        <p>
                        600 200 1200
                        </p>
                      </b>
                    </p>
                  </Col>
              </Row>
              }
              <Assessment getSentValue={this.getSentValue} />
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

export default Summary;
